var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2823_94182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.59392 9.21303C2.6207 9.21303 2.64749 9.21035 2.67427 9.20633L4.92695 8.81125C4.95374 8.80589 4.97919 8.79383 4.99794 8.77375L10.6752 3.09651C10.6876 3.08412 10.6974 3.06941 10.7042 3.0532C10.7109 3.037 10.7143 3.01963 10.7143 3.00209C10.7143 2.98455 10.7109 2.96718 10.7042 2.95098C10.6974 2.93478 10.6876 2.92006 10.6752 2.90767L8.44928 0.680441C8.42383 0.654994 8.39035 0.641602 8.35419 0.641602C8.31802 0.641602 8.28454 0.654994 8.2591 0.680441L2.58186 6.35767C2.56177 6.37776 2.54972 6.40187 2.54436 6.42866L2.14927 8.68133C2.13625 8.75308 2.1409 8.82692 2.16284 8.89647C2.18477 8.96601 2.22333 9.02916 2.27517 9.08044C2.36356 9.16616 2.47472 9.21303 2.59392 9.21303V9.21303ZM3.4966 6.87732L8.35419 2.02107L9.33588 3.00276L4.47829 7.85901L3.28767 8.06928L3.4966 6.87732V6.87732ZM10.9283 10.338H1.07115C0.834096 10.338 0.642578 10.5295 0.642578 10.7666V11.2487C0.642578 11.3077 0.690792 11.3559 0.749721 11.3559H11.2497C11.3087 11.3559 11.3569 11.3077 11.3569 11.2487V10.7666C11.3569 10.5295 11.1653 10.338 10.9283 10.338Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2823_94182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/Edit_pen.99512e013858b236b982d44c9906e6f5.svg";
export { ForwardRef as ReactComponent };